import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { User } from 'lucide-react';

/**
 * Customer picker used when the cashier chooses "Credit" as payment method.
 * The selected customer is stored in the parent; this dialog only renders
 * the list + "Continue" action.
 */
export default function CustomerSelectDialog({
  open,
  onOpenChange,
  customers,
  selectedCustomer,
  setSelectedCustomer,
  onContinue,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90dvh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Select Customer for Credit</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <Input placeholder="Search customers..." className="h-10" />
          <div className="max-h-60 overflow-y-auto space-y-2">
            {customers.map((c) => (
              <Button
                key={c.id}
                variant={selectedCustomer?.id === c.id ? 'default' : 'outline'}
                className={`w-full justify-start h-auto py-3 ${selectedCustomer?.id === c.id ? 'bg-orange-500' : ''}`}
                onClick={() => setSelectedCustomer(c)}
                data-testid={`customer-${c.id}`}
              >
                <User size={18} className="mr-3" />
                <div className="text-left">
                  <p className="font-medium">{c.name}</p>
                  <p className="text-xs opacity-70">{c.phone || 'No phone'}</p>
                </div>
              </Button>
            ))}
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button
            onClick={onContinue}
            disabled={!selectedCustomer}
            className="bg-orange-500 hover:bg-orange-600"
          >
            Continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
